import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import { NavService } from 'shared/nav/nav.service';
import {Dialog} from '../../model/model';

@Component({
  selector: 'dialogs-completion-page',
  templateUrl: 'dialogs-completion-page.html',
  styleUrls: ['dialogs-completion-page.scss'],
})
export class DialogsCompletionPage {

  private _dialog: Dialog;

  constructor(
    public navService: NavService,
    public translateService: TranslateService) {
    this._dialog = <Dialog> this.navService.get('dialog');
  }

  public get dialogTitle(): string {
    if (this._dialog) {
      return this._dialog.title[this.translateService.currentLang];
    }

    return '';
  }

  public onFinishClick(): void {
    this.navService.root('dashboard');
  }

}
